import React, { useState } from 'react';
import { ProjectsTable } from './ProjectsTable';
import translate from 'i18n/translate';

const ProjectsPage = () => {
  const [internationalProjects, setInternationalProjects] = useState(false);
  const [homelandProjects, setHomelandProjects] = useState(true);
  const [homelandProjectsData] = useState([
    {
      id: 9,
      name:
        ' E2E - Znanjem do posla: razvoj veština mladih i javno-privatno partnerstvo u Srbiji',
      value: 328074,
      donated:
        'Švajcarska agencija za razvoj i saradnju / sprovodi NIRAS-IP / Business Innovation Program, Beograd',
      goals: [
        'Organizovanje obuke na radnom mestu mladih koji traže posao pod nazivom: "Operator na liniji za profilisanje"'
      ],
      timeFrom: ' 2019 god',
      timeTo: '2020 god',
      finished: true
    },
    {
      id: 1,
      name:
        'Strategija izvoza članova VMC u Češku Republiku za poljoprivrednu mehanizaciju namenjenu malim i srednjim gazdinstvima',
      value: 1590000,
      donated: 'Ministarstvo ekonomije Republike Srbije',
      goals: [
        'Doprinos stvaranju novih radnih mesta u nedovoljno razvijenim područjima Vojvodine i povećanje konkurentnosti,kroz uvođenje standarda u 20 firmi članica VMC'
      ],
      timeFrom: '29.12.2011',
      timeTo: '05.05.2012',
      finished: true
    },
    {
      id: 2,
      name: 'VMC "klinika"',
      value: 2699600,
      donated: 'Razvojna agencija Srbije',
      goals: [
        'Povećanje konkurentnosti MSPP kroz razvoj i unapređenje usluga koje realizatori projekta pružaju krajnjim korisnicima'
      ],
      timeFrom: '05.07.2017',
      timeTo: '05.01.2018',
      finished: true
    },
    {
      id: 3,
      name:
        'Podzemni kontejner (ICWP) v.2.0 Inovativni zajednički proizvod klastera-unapređena verzija',
      value: 11730000,
      donated: 'Razvojna agencija Srbije',
      goals: [
        'Projekat doprinosi razvoju privrednih subjekata zasnovanom na znanju,inovativnosti, konkurentnosti i poslovnom udruživanju koji treba da stvori snažan, konkurentan i izvozno orijentisan MSPP u lancu vrednosti metalske industrije Srbije'
      ],
      timeFrom: '22.07.2016',
      timeTo: '01.05.2017',
      finished: true
    },
    {
      id: 4,
      name: 'Bolji i napredniji Vojvodina Metal Cluster',
      value: 3500000,
      donated:
        'Pokrajinski sekretarijat za privredu, zapošljavanje i ravnopravnost polova',
      goals: [
        'Strategije razvoja Vojvodina Metal Klastera 2015-2020 sa Akcionim planom',
        'Radionica na temu "MSP i EU fondovi"',
        'Direktore pogledaj'
      ],
      timeFrom: '15.03.2016',
      timeTo: '15.09.2016',
      finished: true
    },
    {
      id: 5,
      name: 'Program podrške inovativnih klastera u 2015',
      value: 4273687,
      donated: 'Nacionalna agencija za regionalni razovoj',
      goals: [
        'Povećanje produktivnosti i konkurentnosti domaćih preduzeća i preduzetnika povezivanjem u klastere',
        'Jačanje saradnje između malih i srednjih preduzeća i preduzetnika sa naučno-istraživačkim organizacijama'
      ],
      timeFrom: '30.10.2015',
      timeTo: '01.06.2016',
      finished: true
    },
    {
      id: 6,
      name: 'Mentoring za sto novoosnovanih i postojećih MSPP i Klastera',
      value: '',
      donated: 'Nacionalna agencija za regionalni razvo',
      goals: [
        'Podrška u jačanju kapaciteta klaster menadžmenta u oblasti tehnološkog razvoja i inovacija',
        'Jačanje međunarodne saradnje i pomoć kod realizacije međunarodnih ugovora'
      ],
      timeFrom: '06.07.2015',
      timeTo: '30.11.2015',
      finished: true
    },
    {
      id: 7,
      name: 'Implementacija ISO standarda',
      value: 1719561,
      donated: 'Ministarstvo ekonomije Republike Srbije',
      goals: [
        'Doprinos stvaranju novih radnih mesta u nedovoljno razvijenim područjima Vojvodine i povećanje konkurentnosti,kroz uvođenje standarda u 20 firmi članica VMC'
      ],
      timeFrom: '29.12.2011',
      timeTo: '05.05.2012',
      finished: true
    },
    {
      id: 8,
      name: 'VMC centar za razvojne projekte - upotreba novih tehnologija',
      value: 280000,
      donated: 'Opština Pančevo',
      goals: [
        'Razvoj i upotreba novih tehnologija',
        'Promocija usluga centra na društvenim mrežama',
        'Nabavka IT opreme'
      ],
      timeFrom: '15.01.2013',
      timeTo: '15.04.2013',
      finished: true
    }
  ]);

  const [internationalProjectsData] = useState([
    {
      id: 7,
      name: 'Sinergija znanja i novo zapošljavanje u konkurentnim MSP',
      value: 86247,
      donated: 'Norveška za vas',
      goals: [
        'Poboljšati poslovne performanse (tržišni potencijal, održivost i konkurentnost) i poboljšati mogućnosti novog zapošljavanja u MSP-malim i srednjim preduzećima metalskog/mašinskog sektora u ciljanim opštinama / gradovima 3. i 4. grupe razvijenosti U Srbiji.'
      ],
      timeFrom: 'Octobar 2020',
      timeTo: 'Avgust 2021',
      finished: false
    },
    {
      id: 1,
      name:
        'The European Union, Innovation & Media Partnership for Action, Collaboration and Transformation in the Western Balkans - EU IMPACT WB',
      value: 780000,
      donated: 'EuropeAid/154870/DH/ACT/Multi',
      goals: [
        'Opšti cilj projekta je da organizacije civilnog društva (OCD), mladi preduzetnici i socijalni inovatori sarađuju da bi efikasnije koristili nove medijske alate za stvaranje novih radnih mesta i promovisanje pitanja društveno-ekonomskih reformi u Svetskoj banci'
      ],
      timeFrom: '01.04.2018',
      timeTo: '31.03.2021',
      finished: false
    },
    {
      id: 2,
      name: 'Innovation and Technology Center for Metal Industry - ITC Mind',
      value: 342300,
      donated: 'Interreg IPA CBC HU-SER 2014-2020',
      goals: [
        'Povećanje konkurentnosti MSP u metalnoj industriji u prekograničnom regionu postavljanjem institucionalnog okvira za podsticanje i generišu inovacije, identifikaciju inovacija, razvoj i implementaciju kao i jačanje potencijala za zapošljavanje.'
      ],
      timeFrom: '01.03.2018',
      timeTo: '29.02.2020',
      finished: true
    },
    {
      id: 3,
      name: 'Inovativni zajednički proizvod klastera',
      value: 6760000,
      donated: 'USAID SLDP - DUNS 49-941-9858',
      goals: [
        'Da se poveća vidljivost VMC članica i poboljša kvalitet dostupnih informacija, poboljšanje usluga koje pruža VMC edukativni centar.',
        'Razvoj inovativnog zajedničkog proizvoda klastera.'
      ],
      timeFrom: '21.11.2014',
      timeTo: '22.05.2015',
      finished: true
    },
    {
      id: 4,
      name: 'VMC Inovativni i poslovno razvojni centar – „VMC Inno Buddy“',
      value: 7829600,
      donated: 'USAID SLDP - DUNS 49-941-9858',
      goals: [
        'Povećanje efikasnosti  skraćenja vremena za dostavljanje odgovora na postavljene zahteve.',
        'Obuka Upravljanja sistemom kvaliteta za min. 30 članica. Povećanje kapaciteta VMC članica za inovativne projekte i identifikacija minimum 5 razvojnih projekata.'
      ],
      timeFrom: '01.12.2013',
      timeTo: '25.07.2015',
      finished: true
    },
    {
      id: 5,
      name:
        'Razvoj podugovaračke strategije za industrijske proizvođače (Promocija uvoza u Švajcarsku)',
      value: 43850,
      donated: 'Switzerland Global Enterprise - SIPPO',
      goals: [
        'C2C (Cluster to Cluster) menadžment, novorazvijena strategija za industrijske podugovarače u Srbiji, čiji je cilj da podrži i održi rast izvoza metalskih firmi iz Srbije u Švajcarsku.',
        'Cilj je da se usaglase i integrišu potrebe švajcarske privrede sa mogućnostima za podugovaranjem sa dobavljačima Srbije'
      ],
      timeFrom: '15.01.2013',
      timeTo: '15.04.2013',
      finished: true
    },
    {
      id: 6,
      name:
        'Povećanje konkurentnosti MMSPP i njihovo osposobljavanje za pisanje projekata prema procedurama EU',
      value: 9200,
      donated:
        'Deutsche Gesellschaft fur Internationale Zusammenarbeit   (GIZ) GmbH',
      goals: [
        'Osnivanje specijalizovane organizacione jedinice  ',
        '„VMC centar za razvojne projekte“'
      ],
      timeFrom: '01.06.2012',
      timeTo: '30.11.2012',
      finished: true
    }
  ]);
  return (
    <div className="projects-container center-container">
      <div className="projects-container-heading">
        <div
          className={`${homelandProjects ? 'active-tab' : ''} mr-4`}
          onClick={() => {
            setHomelandProjects(true);
            setInternationalProjects(false);
          }}
        >
          <h2 className={`${homelandProjects ? 'inactive-tab' : ''} `}>
            {translate('nationalProjects')}
          </h2>
        </div>
        <div
          className={`${internationalProjects ? 'active-tab' : ''}`}
          onClick={() => {
            setHomelandProjects(false);
            setInternationalProjects(true);
          }}
        >
          <h2 className={`${internationalProjects ? 'inactive-tab' : ''}`}>
            {translate('internationalProjects')}
          </h2>
        </div>
      </div>

      <div className="projects">
        <ProjectsTable
          rows={
            homelandProjects ? homelandProjectsData : internationalProjectsData
          }
          rsd={homelandProjects ? true : false}
        />
      </div>
    </div>
  );
};

export default ProjectsPage;
